import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-topbar" }
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("button", {
      class: "bf-topbar__burger",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args))),
      "aria-label": "Menu"
    }, [...(_cache[1] || (_cache[1] = [
      _createElementVNode("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round"
      }, [
        _createElementVNode("path", { d: "M4 6h16M4 12h16M4 18h16" })
      ], -1)
    ]))]),
    _createElementVNode("img", {
      class: "bf-topbar__logo",
      src: _ctx.logoSrc,
      alt: "Bindfy"
    }, null, 8, _hoisted_2),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "bf-topbar__spacer" }, null, -1))
  ]))
}